import firebase from "firebase/app";
import "firebase/firestore";

export class Ticket {
  public id = 0;
  public available_count = 0;
  public buyCount = 0;
  public city = "";
  public createdAt = firebase.firestore.Timestamp.fromDate(new Date());
  public description = "";
  public expirationDate = 0;
  public image_url = "";
  public prefecture = "";
  public price = 0;
  public number = 0;
  public salonGenre = 0;
  public salonId = "";
  public salonIdSystem = "";
  public salonName = "";
  public status = 0;
  public thanksContent = "";
  public ticketId = "";
  public title = "";
  public type: any;
}
